import { ListItemButton, ListItemButtonProps, ListItemDecorator } from '@healthinal/ui';
import { createLink, Link, LinkComponent, MatchRoute } from '@tanstack/react-router';
import { ComponentProps, forwardRef, ReactNode } from 'react';

const ListItemButtonWrapper = forwardRef<HTMLAnchorElement, Omit<ListItemButtonProps<typeof Link>, 'component'>>(
  function ListItemButtonWrapper(props, ref) {
    return <ListItemButton ref={ref} component={Link} {...props} />;
  },
);
const ListItemButtonLink = createLink(ListItemButtonWrapper);

export function MenuLink({
  icon,
  children,
  ...props
}: Omit<ComponentProps<LinkComponent<typeof ListItemButtonWrapper>>, 'mask' | 'from'> & {
  icon?: ReactNode;
  children: ReactNode;
}) {
  return (
    <MatchRoute {...props}>
      {(match) => (
        <ListItemButtonLink {...props} variant={match ? 'solid' : 'plain'}>
          {icon && <ListItemDecorator>{icon}</ListItemDecorator>}
          {children}
        </ListItemButtonLink>
      )}
    </MatchRoute>
  );
}
